import React from 'react';
import './Loader.css';

const Loader = () => {
  return <div className="heart"></div>;
};

export default Loader;
